module.exports = "<script type=\"text/html\" id=\"propertyeditor-dropdown\">\n  <div class=\"svd_custom_select svd_property_editor_dropdown\">\n      <select\n        onmousewheel=\"return false;\"\n        class=\"form-control svd_editor_control\"\n        data-bind=\"value: koValue, disable: readOnly, optionsCaption: optionsCaption, options: koChoices,  optionsValue: 'value',  optionsText: 'text', valueAllowUnset: true,  hasFocus: koHasFocus, attr: { 'aria-label': displayName }\"\n        style=\"width:100%\">\n      </select>\n  </div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-dropdown.html
// module id = 116
// module chunks = 0